import FormLogin from './components/FormLogin';
import LayoutAuth from '../../components/LayoutAuth/index';
import LoginWith from '../../components/LoginWith/inedx';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const { t } = useTranslation();

  return (
    <LayoutAuth
      linkHelper="/sign-up"
      linkHelperMessage={t('login.linkHelperMessage')}
      linkHelperText={t('login.linkHelperText')}
      title={t('login.title')}
    >
      <LoginWith upItems />
      <FormLogin />
    </LayoutAuth>
  );
};
export default Login;
